import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import LandingPage from '../LandingPage';

/**
 * /home — Landing page always rendered regardless of auth state.
 * For logged-in users who want to revisit the landing page.
 */
const HomeLandingRoute: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <LandingPage
      onSignup={() => navigate(user ? '/app' : '/login')}
      onLogin={() => navigate(user ? '/app' : '/login')}
    />
  );
};

export default HomeLandingRoute;
